// 訂單相關翻譯

export const orders = {
    orderList: 'Order List',
    orderNo: 'Order No',
    email: 'Email',
    productName: 'Product Name',
    amount: 'Amount',
    paidAt: 'Paid At',
    noOrderRecords: 'No order records',
    noOrders: 'No Orders',
    noOrdersDescription: 'You don\'t have any order records yet',
    status: 'Status',
    credits: 'Credits',
    operations: 'Operations',
    refund: 'Refund',
    refunding: 'Refunding...',
    refundSuccess: 'Refund request submitted successfully',
    refundFailed: 'Refund request failed',
    refundConfirm: 'Are you sure you want to request a refund for this order?',
    refundNotAvailable: 'Refund not available',
    statusCompleted: 'Completed',
    statusPending: 'Pending',
    statusFailed: 'Failed',
    statusCancelled: 'Cancelled',
    statusRefunded: 'Refunded'
  };
